import { notifyMemberViaEmailTypes } from 'pages/AutomationEngine/helpers';
import type { EmailSendOptionsTeamMember } from './email-send-options/types';

export const isTeamMemberValid = (teamMember?: EmailSendOptionsTeamMember) => {
  if (teamMember?.type === notifyMemberViaEmailTypes.NONE) {
    return true;
  }

  if (teamMember?.type === notifyMemberViaEmailTypes.LAST_ACTIVE) {
    return true;
  }

  if (teamMember?.type === notifyMemberViaEmailTypes.OWNER) {
    return true;
  }

  if (
    teamMember?.type === notifyMemberViaEmailTypes.TEAM_SELECTOR_FIELD &&
    teamMember?.field?.value
  ) {
    return true;
  }

  if (
    teamMember?.type === notifyMemberViaEmailTypes.LAST_ACTIVE_ROLE &&
    teamMember?.role?.value
  ) {
    return true;
  }

  if (
    teamMember?.type === notifyMemberViaEmailTypes.SPECIFIC_TEAM_MEMBERS &&
    teamMember?.employees?.length
  ) {
    return true;
  }

  return false;
};
